<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-end flex-column">
          <div class="d-flex justify-content-between align-items-center">
            <p class="fw-bolder">
              نقش ها و مسئولیت ها در فرآیند - RACI
              / {{$route.params.title}}
            </p>
            <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)" style="transform: translateY(-0.5vw)">برگشت</button>
          </div>
          <div v-if="!is_filter">
            <button
                title="در قسمت فیلتر می توانید بر اساس طبقه - گروه - فرآیند و زیر فرآیند اطلاعات را مشاهده کنید"
                @click.prevent="is_filter=true" class="btn mx-3 btn-primary btn-submit-1"
                    style="width: 8vw;">
              <Filter style="width: 1vw; margin-left: 0.5vw;"/>
              فیلتر نتایج
            </button>
          </div>
          <div v-if="headers.length && is_filter" class="d-flex align-items-center justify-content-start ">
            <button  @click.prevent="floorsMethod" class="btn mx-3 btn-primary btn-submit-1"
                    style="width: 11vw;">
              {{ all_floors.find((item)=>item.code === ids[0])?.title ? all_floors.find((item)=>item.code === ids[0])?.title.slice(-14) : 'انتخاب طبقه' }}
              {{ids.length > 1? '...' : ''}}

            </button>
            <button v-if="all_groups.length!==0" @click.prevent="groupsMethod" class="btn mx-3 btn-primary btn-submit-1"
                    style="width: 11vw;">
              {{ all_groups.find((item)=>item.code === ids_groups[0])?.title ? all_groups.find((item)=>item.code === ids_groups[0])?.title.slice(-14) : 'انتخاب گروه' }}
              {{ids_groups.length > 1? '...' : ''}}

            </button>
            <button v-if="all_process.length" @click.prevent="ProcessFilterMethod" class="btn mx-3 btn-primary btn-submit-1"
                    style="width: 11vw;">
              {{ all_process.find((item)=>item.code === ids_process[0])?.title ? all_process.find((item)=>item.code === ids_process[0])?.title.slice(-14) : 'انتخاب فرآیند' }}
              {{ids_process.length > 1? '...' : ''}}

            </button>
            <button v-if="all_sub_process.length" @click.prevent="SubProcessFilter=true" class="btn mx-3 btn-primary btn-submit-1"
                    style="width: 11vw;">
              {{ all_sub_process.find((item)=>item.code === ids_sub_process[0])?.title ? all_sub_process.find((item)=>item.code === ids_sub_process[0])?.title.slice(-14) : 'انتخاب زیر فرآیند' }}
              {{ids_sub_process.length > 1? '...' : ''}}
            </button>
            <button @click="resetFilter" class="btn" title="لغو">❌</button>

          </div>

        </div>
        <hr class="mt-3 mb-3">
        <center v-if="!items.length">
          موردی یافت نشد
        </center>



        <table class="table table-striped" v-if="headers.length && items.length">
          <tbody>
          <tr>

            <th>

            </th>
            <th v-for="item in headers">{{ item.fullname }}</th>


          </tr>
          <tr  v-for="task in items"   >
            <td style="width: 10vw !important; text-align: right">{{ task.title }}</td>
            <td class="hover" style="width: 2vw !important; font-weight: 900" v-for="item in headers" :style="GetBG(item.id, task.R, task.A, task.C, task.I)">
              {{ GetType(item.id, task.R, task.A, task.C, task.I) }}
            </td>
          </tr>


          </tbody>
        </table>


      </div>
    </div>
  </div>


  <!--  modals *****************************-->
  <div dir="rtl" class="modal__error slide-top" v-show="showProcessFilter" style="z-index: 999999999999999">
    <div>
      <p>فیلتر بر اساس طبقه</p>
      <p @click="showProcessFilter=!showProcessFilter">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <tbody>
        <tr>

          <th style="width: 1vw;"></th>
          <th>فرآیند</th>

        </tr>
        <tr v-for="item in all_floors">
          <td>
            <input type="checkbox"
                   v-model="ids"
                   :value="item.code"
                   :id="`p_${item.id}`"
            >
          </td>
          <td><label style="display:block;" :for="`p_${item.id}`">{{item.title}}</label></td>
        </tr>



        </tbody>
      </table>
      <button @click.prevent="submitFloors">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="showGroupFilter" style="z-index: 999999999999999">
    <div>
      <p>فیلتر بر اساس گروه</p>
      <p @click="showGroupFilter=!showGroupFilter">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <tbody>
        <tr>

          <th style="width: 1vw;"></th>
          <th>فرآیند</th>

        </tr>
        <tr v-for="item in all_groups">
          <td>
            <input type="checkbox"
                   v-model="ids_groups"
                   :value="item.code"
                   :id="`p_${item.id}`"
            >
          </td>
          <td><label style="display:block;" :for="`p_${item.id}`">{{item.title}}</label></td>
        </tr>



        </tbody>
      </table>
      <button @click.prevent="submitGroup">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="ProcessFilter" style="z-index: 999999999999999">
    <div>
      <p>فیلتر بر اساس فرآیند</p>
      <p @click="ProcessFilter=!ProcessFilter">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <tbody>
        <tr>

          <th style="width: 1vw;"></th>
          <th>فرآیند</th>

        </tr>
        <tr v-for="item in all_process">
          <td>
            <input type="checkbox"
                   v-model="ids_process"
                   :value="item.code"
                   :id="`d_${item.id}`"
            >
          </td>
          <td><label style="display:block;" :for="`d_${item.id}`">{{item.title}}</label></td>
        </tr>



        </tbody>
      </table>
      <button @click.prevent="submitProcess">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="SubProcessFilter" style="z-index: 999999999999999">
    <div>
      <p>فیلتر بر اساس زیر فرآیند</p>
      <p @click="SubProcessFilter=!SubProcessFilter">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <tbody>
        <tr>

          <th style="width: 1vw;"></th>
          <th>فرآیند</th>

        </tr>
        <tr v-for="item in all_sub_process">
          <td>
            <input type="checkbox"
                   v-model="ids_sub_process"
                   :value="item.code"
                   :id="`d_${item.id}`"
            >
          </td>
          <td><label style="display:block;" :for="`d_${item.id}`">{{item.title}}</label></td>
        </tr>



        </tbody>
      </table>
      <button @click.prevent="submitSubProcess">تایید</button>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Filter from "@/components/Icons/Filter.vue";

export default {
  name: 'HomeView',
  components: {
    Filter,
    Sidebar,
    splash
  },
  data() {
    return {
      showProcessFilter: false,
      showGroupFilter: false,
      ProcessFilter: false,
      select_inserter: false,
      SubProcessFilter: false,
      is_filter: false,
      inserterId: '',
      search_inserter: '',
      itemsOrgan: [],
      all_inserter: [],
      ids_process: [],
      nameRoute: '',
      headers: [],
      items: [],
      all_floors: [],
      ids_sub_process: [],
      ids: [],
      id_route: this.$route['params']['id'],

      ids_groups: [],
      all_groups: [],
      all_process: [],
      all_sub_process: [],

    }
  },
  methods: {
    submitSubProcess(){
      this.items.length = 0
      let items = JSON.stringify(this.ids_sub_process)
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('processes_id',items)
      formdata.append('id',this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/RolesAndResponsibilities/index_by_id`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result['headers'].length !== 0) {
              this.headers.length = 0
              this.headers = [...result.headers]


            }
            if (result['items'].length !== 0) {
              this.items.length = 0
              this.items = [...result.items]


            }
            this.SubProcessFilter = false

          })
          .catch();
    },

    submitProcess(){
      this.items.length = 0
      let items = JSON.stringify(this.ids_process)
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('ids',items)
      formdata.append('id',this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all/process`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_sub_process.length=0
              this.all_sub_process = [...response.all]
              this.ProcessFilter=false

              var myHeaders = new Headers();
              myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

              var formdata = new FormData();
              formdata.append('processes_id',items)
              formdata.append('id',this.id_route)

              var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
              };
              fetch(`${this.base_url}/RolesAndResponsibilities/index_by_id`, requestOptions)
                  .then(response => response.json())
                  .then(result => {
                    // this.all_inserter.length = 0

                    if (result['headers'].length !== 0) {
                      this.headers.length = 0
                      this.headers = [...result.headers]


                    }
                    if (result['items'].length !== 0) {
                      this.items.length = 0
                      this.items = [...result.items]


                    }

                  })
                  .catch();

            }

          })
          .catch();
    },
    groupsMethod(){
      this.showGroupFilter = true
    },
    processMethod(){},
    subProcessMethod(){
    },
    ProcessFilterMethod(){
      this.ProcessFilter = true
    },
    submitGroup(){
      this.items.length = 0
      let items = JSON.stringify(this.ids_groups)
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('id',this.id_route)

      formdata.append('ids',items)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all/process`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_process.length=0
              this.all_process = [...response.all]
              this.showGroupFilter=false
              var myHeaders = new Headers();
              myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

              var formdata = new FormData();
              formdata.append('processes_id',items)

              formdata.append('id',this.id_route)
              var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
              };
              fetch(`${this.base_url}/RolesAndResponsibilities/index_by_id`, requestOptions)
                  .then(response => response.json())
                  .then(result => {
                    // this.all_inserter.length = 0

                    if (result['headers'].length !== 0) {
                      this.headers.length = 0
                      this.headers = [...result.headers]


                    }
                    if (result['items'].length !== 0) {
                      this.items.length = 0
                      this.items = [...result.items]


                    }

                  })
                  .catch();

            }

          })
          .catch();
    },

    submitFloors(){
      this.items.length = 0
      let items = JSON.stringify(this.ids)
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('ids',items)
      formdata.append('id',this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all/process`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_groups.length=0
              this.all_groups = [...response.all]
              this.showProcessFilter=false
              var myHeaders = new Headers();
              myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

              var formdata = new FormData();
              formdata.append('processes_id',items)

              formdata.append('id',this.id_route)
              var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
              };
              fetch(`${this.base_url}/RolesAndResponsibilities/index_by_id`, requestOptions)
                  .then(response => response.json())
                  .then(result => {
                    // this.all_inserter.length = 0

                    if (result['headers'].length !== 0) {
                      this.headers.length = 0
                      this.headers = [...result.headers]


                    }
                    if (result['items'].length !== 0) {
                      this.items.length = 0
                      this.items = [...result.items]


                    }

                  })
                  .catch();

            }

          })
          .catch();
    },
    floorsMethod(){
      this.showProcessFilter=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('id',this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all/floors`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_floors.length=0
              this.all_floors = [...response.all]

            }

          })
          .catch();
    },
    GetBG(task_id, R, A, C, I) {
      if (R && R.length > 0) {
        const foundR = R.find(item => item.id === parseInt(task_id));
        if (foundR) {
          return 'background: red';
        }
      }
      if (A && A.id === parseInt(task_id)) {
        return 'background: orange';
      }
      if (C && C.id === parseInt(task_id)) {
        return 'background: yellow';
      }
      if (I && I.id === parseInt(task_id)) {
        return 'background: green';
      }
      return ''; // در صورت عدم مطابقت، استایل خالی را برگردانید
    },

    GetType(task_id, R, A, C, I) {
      if (R && R.length > 0) {
        const foundR = R.find(item => item.id === parseInt(task_id));
        if (foundR) {
          return 'R';
        }
      }
      if (A && A.id === parseInt(task_id)) {
        return 'A';
      }
      if (C && C.id === parseInt(task_id)) {
        return 'C';
      }
      if (I && I.id === parseInt(task_id)) {
        return 'I';
      }
      return ''; // در صورت عدم مطابقت، رشته خالی را برگردانید
    },

    allItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('id',this.id_route)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/RolesAndResponsibilities/index`, requestOptions)
          .then(response => response.json())
          .then(result => {
            // this.all_inserter.length = 0

            if (result['headers'].length !== 0) {
              this.headers.length = 0
              this.headers = [...result.headers]


            }
            if (result['items'].length !== 0) {
              this.items.length = 0
              this.items = [...result.items]


            }

          })
          .catch();
    },

    showListInserter() {
      this.select_inserter = true

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)

              })
              this.select_inserter3 = true

            }

          })
          .catch();
    },
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/')
      }

    },
    resetFilter(){
      this.is_filter = false
      this.all_process.length=0
      this.all_sub_process.length=0
      this.all_groups.length=0
      this.allItems()

    }
  },
  mounted() {
    this.checkIsMother()
    this.allItems()
  },

  computed: {
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
  }
}
</script>
<style scoped>
.hover{
  transition: all ease 500ms;
}
.hover:hover{
  cursor: pointer;
  box-shadow: 0 0 1px 1px #777;
}
</style>